import React, { useCallback, useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { api } from '../../utils/api'
import UserLayout from '../../layouts/UserLayout'
import { getFromStorage } from '../../utils/storage'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainBlue, mainGreen } from '../../utils/color'

export default function BillManagement() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [stores, setStores] = useState([])
	const [loadingStores, setLoadingStores] = useState(true)
	const getStores = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_STORES_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStores(response.data)
				setLoadingStores(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, dispatch],
	)

	useEffect(() => {
		getStores()
	}, [getStores])

	return (
		<UserLayout>
			{loadingStores ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Box
					sx={{
						marginTop: '10px',
						padding: '10px 20px',
						display: 'flex',
						flexWrap: 'wrap',
						maxWidth: 992,
						marginLeft: 'auto',
						marginRight: 'auto',
					}}>
					{stores?.map((store, index) => {
						return (
							<Box key={index} sx={{ width: '50%', position: 'relative' }}>
								<Button
									onClick={() => {
										navigate(`/admin/bill/${store._id}`)
									}}
									variant='contained'
									sx={{
										m: 1,
										display: 'flex',
										padding: '15px 0 5px 0',
										width: '90%',
										background: mainGreen,
										'&:hover': { background: mainGreen },
									}}>
									<Box display='flex' flexDirection='column' alignItems='center'>
										<HomeWorkIcon sx={{ fontSize: '40px' }} />
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'flex-end',
												mt: 1,
												mb: 1,
												background: mainBlue,
												padding: '5px 10px',
												borderRadius: '10px',
											}}>
											<RequestQuoteIcon />
											<Typography sx={{ ml: 1, fontSize: '14px' }}>{store.name}</Typography>
										</Box>
									</Box>
								</Button>
							</Box>
						)
					})}
				</Box>
			)}
		</UserLayout>
	)
}
